import type { RootStore } from '.';
import { trackAction } from './analytics';

/** Session permissions were revoked but member doc cleanup failed — safe to retry (CRE-282). */
export function isPartialMemberRemovalError(err: unknown): boolean {
  return (
    typeof err === 'object' &&
    err !== null &&
    'code' in err &&
    (err as { code: string }).code === 'functions/failed-precondition'
  );
}

export function showMemberRemovalRetrySnackbar(
  rootStore: RootStore,
  errorMessage: string,
  retry: () => void | Promise<unknown>,
): void {
  rootStore.uiSnackbarStore.setSnackbarDetails({
    description: errorMessage,
    actionText: 'Retry',
    fn: () => {
      trackAction('member_removal_retried', 'snackbar_retry');
      // Retry may rethrow after partial removal — swallow unhandled rejection (CRE-282).
      void Promise.resolve(retry()).catch(() => {});
    },
  });
}
